import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities } from 'redux-modules/entity'

import api from 'api'

const FETCH_REQUEST = 'realhub/publicationInspection/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/publicationInspection/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/publicationInspection/FETCH_FAILURE'

const SEND_REQUEST = 'realhub/publicationInspection/SEND_REQUEST'
const SEND_SUCCESS = 'realhub/publicationInspection/SEND_SUCCESS'
const SEND_FAILURE = 'realhub/publicationInspection/SEND_FAILURE'

// Initial State
const initialState = {
  result: [],
  loaded: false,
  loading: false,
  sending: false,
  errors: [],
}

// Actions
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload = {}){
  return {
    type: FETCH_SUCCESS,
    result: payload.result,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function sendRequest(){
  return {
    type: SEND_REQUEST,
  }
}

export function sendSuccess(){
  return {
    type: SEND_SUCCESS,
  }
}

export function sendFailure(errors = []){
  return {
    type: SEND_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function loadPublicationInspections(options){
  return (dispatch) => {
    // Set Loading
    dispatch(fetchRequest())

    const promise = api('/admin/publication_inspections.json', options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.PUBLICATION_INSPECTION_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess(normalizedJson))
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

export function sendPublicationInspectionsAlert(params, options, callback){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      ...params,
    }),
  }

  return (dispatch) => {
    dispatch(sendRequest())

    const promise = api('/admin/publication_inspections/send_alert.json', options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        dispatch(sendSuccess())

        if (callback) callback()

        return json
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(sendFailure(errors))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        result: action.result,
        errors: [],
      })
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        loaded: false,
        errors: action.errors,
      })
    case SEND_REQUEST:
      return Object.assign({}, state, {
        sending: true,
      })
    case SEND_SUCCESS:
      return Object.assign({}, state, {
        sending: false,
        errors: [],
      })
    case SEND_FAILURE:
      return Object.assign({}, state, {
        sending: false,
        errors: action.errors,
      })
    default:
      return state
  }
}
